module.exports = __webpack_public_path__ + "assets/img/code4.589a033a.png";